import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FinalScreenWrapper from './FinalScreen.styles';
import { Button } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import authAction from '@iso/redux/auth/actions';

const { logout } = authAction;

const FinalScreen = (props) => {
  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => Boolean(state.Auth?.idToken));
  const {
    cancelModal,
    shouldLogout,
    fallbackPath = '/manage-properties',
  } = props;

  const queryParams = React.useMemo(
    () => queryString.parse(location.search),
    [location.search]
  );

  const backLink = React.useMemo(() => {
    const rawValue = queryParams.back_link;
    if (typeof rawValue !== 'string') {
      return '';
    }
    const trimmed = rawValue.trim();
    if (!trimmed) {
      return '';
    }
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }, [queryParams.back_link]);

  const resolvedShouldLogout =
    typeof shouldLogout === 'boolean' ? shouldLogout : Boolean(cancelModal);

  const handlePrimaryAction = () => {
    if (resolvedShouldLogout) {
      dispatch(logout());
    }

    if (cancelModal) {
      cancelModal();
      return;
    }

    if (isLoggedIn) {
      const target = backLink || fallbackPath;
      if (/^https?:\/\//i.test(target)) {
        window.location.assign(target);
      } else {
        history.push(target);
      }
    } else {
      const redirectPath = backLink || fallbackPath;
      if (redirectPath) {
        const encoded = redirectPath.startsWith('/')
          ? redirectPath.slice(1)
          : redirectPath;
        history.push(`/signin?back_link=${encodeURIComponent(encoded)}`);
      } else {
        history.push('/signin');
      }
    }
  };
  
  return (
    <FinalScreenWrapper>
      <h3 className="final-msg">You have completed the form, Thank you.</h3>
      <span className="final-desc-msg">You are now able to close the window or explore the platform by creating a free property your self</span>
      <div className="final-button-block">
        <Button type="primary" className="btn-success" size="medium" onClick={handlePrimaryAction}>
            {cancelModal ? 'Close Window' : 'Go Back'}
        </Button>
        <Button type="primary" className="btn-success" size="medium" onClick={() => history.push("/manage-properties")}>
            Create my own property map
        </Button>
      </div>
    </FinalScreenWrapper>
  )
}

export default FinalScreen;
